import gql from 'graphql-tag'

export default gql`
  fragment documentPrepareFragment on Document {
    _id
    fieldsAssigned
    signers {
      name
      email
    }
    feaSigners {
      name
      email
    }
    faceSigners {
      id
      name
      email
    }
    pages {
      url
      index
      width
      height
    }
    fields {
      id
      filler
      type
      label
      required
      page
      x
      y
      width
      height
      value {
        text
        signatureId
        checked
      }
      name
      validation
      textSize
    }
  }
`



// WEBPACK FOOTER //
// ./src/App/Pages/Sign/Prepare/fragment.js